import Hoek from "@hapi/hoek";
const dataURLtoFile = (dataURl, filename)=>{
    var arr = dataURl.split(","), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([
        u8arr
    ], filename, {
        type: mime
    });
};
const getExtension = (filename, isVideo)=>{
    var name = filename.split(".");
    return {
        fileName: name[0],
        extension: isVideo ? "png" : name[1] || "png"
    };
};
const createImage = (canvas, filename, pageNum)=>{
    let image = canvas.toDataURL();
    let success = image.length > 100000;
    let file;
    let imageUrl = "";
    if (success) {
        // @ts-ignore
        file = dataURLtoFile(image, filename);
        // @ts-ignore
        imageUrl = URL.createObjectURL(file);
    }
    return {
        pageNum,
        success,
        file,
        image,
        imageUrl
    };
};
const defaultOptions = {
    width: 100,
    height: 200,
    scale: 1,
    rotate: 0
};
function createCanvas(page, options) {
    const mergedOptions = Hoek.applyToDefaults(defaultOptions, options);
    try {
        const rotation = mergedOptions.rotate === 0 ? page.rotate : page.rotate + mergedOptions.rotate;
        const dpRatio = window.devicePixelRatio;
        const adjustedScale = mergedOptions.scale * dpRatio;
        const viewport = page.getViewport({
            scale: adjustedScale,
            rotation
        });
        const canvas = document.createElement("canvas");
        canvas.style.width = "".concat(viewport.width / dpRatio, "px");
        canvas.style.height = "".concat(viewport.height / dpRatio, "px");
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        const canvasContext = canvas.getContext("2d");
        if (!canvasContext) {
            return;
        }
        return page.render({
            canvasContext,
            viewport
        }).promise.then(function() {
            return Promise.resolve(canvas);
        }).catch((err)=>{
            ;
            return Promise.reject(err);
        });
    } catch (err) {
        return Promise.reject(err);
    }
}
export { dataURLtoFile, getExtension, createImage, createCanvas };
